import {
    Directive,
    HostListener,
    Input,
    OnInit,
} from '@angular/core';

import * as XRegExp from 'xregexp';

// Polyfill ClipboardEvent IE11
interface PolyClipboardEvent {
    clipboardData: any;
    preventDefault: Function;
}

/**
 * Directive to prevent the user from entering
 * invalid characters into an input field,
 * either by typing character by character or
 * by pasting into the fields
 *
 * @input: regex string to match the whole value
 */
@Directive({
    selector: '[uiRestrictInput]',
})
export class RestrictInputDirective implements OnInit {
    @Input()
    public uiRestrictInput!: string;
    private _allowedRegex!: RegExp;

    ngOnInit() {
        this._allowedRegex = XRegExp(this.uiRestrictInput);
    }

    @HostListener('keydown', ['$event'])
    keyDown(ev: KeyboardEvent) {
        if (!(ev instanceof KeyboardEvent)) { return; }

        const event = {
            ctrlKey: ev.ctrlKey,
            key: ev.key,
            metaKey: ev.metaKey,
        };
        // normalize event key
        // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values#Whitespace_keys
        if (event.key === 'Spacebar') {
            event.key = ' ';
        }
        // allow special commands: copy-pasting, select all
        if ((event.ctrlKey || event.metaKey) &&
            ['A', 'a', 'C', 'c', 'V', 'v', 'X', 'x'].indexOf(event.key) !== -1) {
            return;
        }

        // allow non-character events (backspace, delete, arrowleft, tab etc)
        // but not numpad keys, which will be verified by the regex
        if (event.key.length > 1 &&
            ['Divide', 'Decimal', 'Add', 'Multiply', 'Subtract'].indexOf(event.key) === -1) {
            return;
        }

        if (this._allowedRegex && !this._allowedRegex.test(event.key)) {
            ev.preventDefault();
        }
    }

    @HostListener('paste', ['$event'])
    paste(event: PolyClipboardEvent) {
        const data = event.clipboardData || (window as any)['clipboardData']; // IE11 bug ;(
        if (!this._allowedRegex.test(data.getData('text'))) {
            event.preventDefault();
        }
    }
}
